



























































































import { Component, Watch, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import AlertIcon from "vue-material-design-icons/Alert.vue";
import VulnerabilityAPIService from "@/services/VulnerabilityAPIService";
import { LANGUAGES } from "@/shared/languages";
import NavBar from "@/components/NavBar.vue";
import FooterBar from "@/components/FooterBar.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
import DownloadLoader from "@/components/DownloadLoader.vue";
import VulnerabilityTranslate from "@/components/VulnerabilityTranslate.vue";
import PlatformIcon from "@/components/PlatformIcon.vue";
import SidebarVulnerability from "@/components/SidebarVulnerability.vue";
import PopoverInfo from "@/components/PopoverInfo.vue";

@Component({
  components: {
    NavBar,
    BreadCrumb,
    DownloadLoader,
    VulnerabilityTranslate,
    PlatformIcon,
    SidebarVulnerability,
    FooterBar,
    AlertIcon,
    PopoverInfo
  }
})
export default class VulnerabilityTranslateView extends Vue {
  private id = this.$route.params.id;
  private vulnerabilities = [];
  private languageSwitchDisabled = false;

  private branch = localStorage.getItem("branch");
  private language = "ja";
  private isLoadingMasterVulnerabilities = true;
  private isLoadingBranchVulnerabilities = true;
  private allLangs = LANGUAGES.map(l => l.key);
  private hasEditBranch = false;
  private branchNotFound = false;

  @Watch("$store.state.languageCounter")
  private watchLanguageSwitch() {
    this.language = this.$store.getters.getLanguage;
    this.getVulnerabilities();
  }

  @Watch("$store.state.modifiedVulnerabilitiesCounter")
  private watchModifiedVulnerabilities() {
    this.setLangSwitchDisabled();
  }

  getVulnerability(id: string, lang: string) {
    const vid = parseInt(id);
    const v = this.$store.getters.getVulnerability(vid, lang);
    return v;
  }

  hasAllLangVulns(vulnerabilities) {
    if (!vulnerabilities) {
      return false;
    }
    for (const lang of this.allLangs) {
      if (Object.keys(vulnerabilities[lang]).length === 0) {
        return false;
      }
    }
    return true;
  }

  initModifiedVulnerabilities() {
    const modifiedVulns = localStorage.getItem("modifiedVulnerabilities");
    if (modifiedVulns) {
      const mvs = JSON.parse(modifiedVulns);
      const isValidMVs = this.hasAllLangVulns(mvs);
      if (isValidMVs) {
        for (const lang of this.allLangs) {
          Object.keys(mvs[lang]).forEach(k => {
            this.$store.commit("saveModifiedVulnerability", {
              lang: lang,
              id: k,
              hash: mvs[lang][k]["hash"],
              vulnerability: mvs[lang][k]["vulnerability"]
            });
          });
        }
        return;
      }
    }

    this.$store.commit("initModifiedVulnerabilities");
    const modifiedVulnerabilities = this.$store.getters
      .getModifiedVulnerabilities;
    localStorage.setItem(
      "modifiedVulnerabilities",
      JSON.stringify(modifiedVulnerabilities)
    );
  }

  formatField(field) {
    return {
      content: field.content,
      updatedOn: field.updatedOn
    };
  }

  formatVulnerability(v) {
    return {
      id: v.id,
      key: v.key,
      platform: v.platform,
      updatedOn: v.updated_on,
      name: this.formatField(v.name),
      question: this.formatField(v.question),
      summary: this.formatField(v.description),
      description: this.formatField(v.intro),
      businessImplication: this.formatField(v.business_implication),
      compliant: this.formatField(v.compliant),
      nonCompliant: this.formatField(v.non_compliant),
      successMessage: this.formatField(v.success_message),
      relatedTo: this.formatField(v.related_to)
    };
  }

  async fetchVulnerabilities(branch, langs = this.allLangs) {
    return await VulnerabilityAPIService.get(branch)
      .then(response => response.data)
      .then(data => {
        const vulnerabilities = {};
        for (const lang of langs) {
          vulnerabilities[lang] = data[lang].reduce((acc, curr) => {
            acc[curr.id] = this.formatVulnerability(curr);
            this.$store.commit("saveVulnerability", {
              lang: lang,
              id: curr.id,
              vulnerability: acc[curr.id]
            });
            return acc;
          }, {});
        }
        this.isLoadingBranchVulnerabilities = false;
        return vulnerabilities;
      })
      .catch(err => {
        if (err.response.status == 404) {
          this.branchNotFound = true;
        }
        this.$toast.error(
          "Coudld not load translations for your session. Try reloading",
          {
            timeout: 5000
          }
        );
        const enVulns = this.$store.getters.getVulnerabilitiesForLang("en");
        for (const lang of langs) {
          Object.keys(enVulns).forEach(id => {
            this.$store.commit("saveVulnerability", {
              lang: lang,
              id: parseInt(id),
              vulnerability: null
            });
          });
        }
        this.isLoadingBranchVulnerabilities = false;
        return;
      });
  }

  async getMasterVulnerabilities() {
    const masterCachedOn = localStorage.getItem("masterVulnCachedOn");
    if (
      masterCachedOn &&
      dayjs(masterCachedOn).diff(dayjs(), "hour") <
        parseInt(process.env.VUE_APP_CACHE_TIMEOUT)
    ) {
      const vulnerabilities = localStorage.getItem("masterVulnerabilities");
      if (vulnerabilities) {
        this.vulnerabilities = JSON.parse(vulnerabilities);
        if (this.hasAllLangVulns(this.vulnerabilities)) {
          for (const lang of this.allLangs) {
            Object.keys(this.vulnerabilities[lang]).forEach(k => {
              this.$store.commit("saveVulnerability", {
                lang: lang,
                id: k,
                vulnerability: this.vulnerabilities[lang][k]
              });
            });
          }
          this.isLoadingMasterVulnerabilities = false;
          return;
        }
      }
    }

    return await VulnerabilityAPIService.get("master")
      .then(response => response.data)
      .then(data => {
        const vulnerabilities = {};
        for (const lang of ["en"]) {
          vulnerabilities[lang] = data[lang].reduce((acc, curr) => {
            acc[curr.id] = this.formatVulnerability(curr);
            this.$store.commit("saveVulnerability", {
              lang: lang,
              id: curr.id,
              vulnerability: acc[curr.id]
            });
            return acc;
          }, {});
        }
        for (const lang of this.allLangs) {
          vulnerabilities[lang] = data[lang].reduce((acc, curr) => {
            acc[curr.id] = this.formatVulnerability(curr);
            this.$store.commit("saveMasterVulnerability", {
              lang: lang,
              id: curr.id,
              vulnerability: acc[curr.id]
            });
            return acc;
          }, {});
        }
        this.isLoadingMasterVulnerabilities = false;
        return vulnerabilities;
      })
      .catch(() => {
        this.$toast.error("Could not load, please reload");
        this.isLoadingMasterVulnerabilities = false;
        return;
      });
  }

  async getVulnerabilities() {
    const cachedOn = localStorage.getItem("vulnCachedOn");
    if (
      cachedOn &&
      dayjs(cachedOn).diff(dayjs(), "hour") <
        parseInt(process.env.VUE_APP_CACHE_TIMEOUT)
    ) {
      const vulnerabilities = localStorage.getItem("vulnerabilities");
      if (vulnerabilities) {
        this.vulnerabilities = JSON.parse(vulnerabilities);
        if (this.hasAllLangVulns(this.vulnerabilities)) {
          for (const lang of ["en"]) {
            Object.keys(this.vulnerabilities[lang]).forEach(k => {
              this.$store.commit("saveVulnerability", {
                lang: lang,
                id: k,
                vulnerability: this.vulnerabilities[lang][k]
              });
            });
          }
          this.isLoadingMasterVulnerabilities = false;

          for (const lang of this.allLangs.filter(l => l !== "en")) {
            if (
              Object.values(this.vulnerabilities[lang]).filter(v => v == null)
                .length == 0
            ) {
              Object.keys(this.vulnerabilities[lang]).forEach(k => {
                this.$store.commit("saveVulnerability", {
                  lang: lang,
                  id: k,
                  vulnerability: this.vulnerabilities[lang][k]
                });
              });
              this.isLoadingBranchVulnerabilities = false;
              this.initModifiedVulnerabilities();
              return;
            }
          }
        }
      }
    }

    await this.getMasterVulnerabilities();
    if (this.$store.getters.hasEditBranch) {
      await this.fetchVulnerabilities(
        this.$store.getters.getBranch,
        this.allLangs.filter(l => l !== "en")
      );
    }
    this.vulnerabilities = await this.$store.getters.getVulnerabilities;

    localStorage.setItem(
      "vulnerabilities",
      JSON.stringify(this.vulnerabilities)
    );
    localStorage.setItem("vulnCachedOn", dayjs().toISOString());

    this.initModifiedVulnerabilities();
    return;
  }

  async setLangSwitchDisabled() {
    const modifiedVulns = localStorage.getItem("modifiedVulnerabilities");
    if (modifiedVulns) {
      const mvs = JSON.parse(modifiedVulns);
      const isValidMVs = this.hasAllLangVulns(mvs);
      if (isValidMVs) {
        for (const lang of this.allLangs) {
          const mvFiltered = await Object.keys(mvs[lang]).filter(
            k => !!mvs[lang][k]["vulnerability"]
          );
          if (mvFiltered.length > 0) {
            this.languageSwitchDisabled = true;
          } else {
            this.languageSwitchDisabled = false;
          }
        }
      }
    }
  }

  isEnUpdated(enUpdatedOn, enId) {
    if (!this.vulnerabilities[this.language][enId]) {
      return false;
    }
    if (!enUpdatedOn || this.vulnerabilities[this.language][enId].updatedOn) {
      return false;
    }
    if (
      new Date(enUpdatedOn) >
      new Date(this.vulnerabilities[this.language][enId].updatedOn)
    ) {
      return true;
    }
    return false;
  }

  sort(arr) {
    return arr.reduce((acc, curr) => {
      acc[curr.id] = curr;
      return acc;
    }, {});
  }

  async restoreModifiedVulnerability() {
    const mvs = await this.$store.getters.getModifiedVulnerabilities;
    for (const lang of this.allLangs) {
      await Object.keys(mvs[lang])
        .filter(k => !!mvs[lang][k]["vulnerability"])
        .forEach(k => {
          return Object.keys(mvs[lang][k]["vulnerability"]).forEach(f => {
            this.vulnerabilities[this.language][k][f] =
              mvs[lang][k]["vulnerability"][f];
          });
        });
    }
  }

  mounted() {
    this.hasEditBranch = this.$store.getters.hasEditBranch;
    if (!this.hasEditBranch) {
      this.$router.push({
        name: "vulnerability",
        params: {
          id: this.$route.params.id
        }
      });
    }

    this.$store.commit("initLanguage");
    this.language = this.$store.getters.getLanguage;

    this.getVulnerabilities();
    this.restoreModifiedVulnerability();
    this.setLangSwitchDisabled();
  }
}
